// OneTrust + gtag, production builds only (`import.meta.env.PROD`).
// Staging/sandbox/prod are `vite build` artifacts, so they get these tags;
// `vite` serve does not. Keys come from window.env after /env.js.
type RuntimeEnv = {
  VITE_GOOGLE_ADWORDS_KEY?: string;
  VITE_GOOGLE_ANALYTICS_KEY?: string;
};

type EnvHost = { env?: RuntimeEnv };

function insertScript(
  attrs: {
    src?: string;
    type: string;
    charset?: string;
    domainScript?: string;
    className?: string;
    async?: boolean;
  },
  text?: string,
): void {
  const el = document.createElement('script');
  if (attrs.src) el.src = attrs.src;
  el.type = attrs.type;
  if (attrs.charset) el.setAttribute('charset', attrs.charset);
  if (attrs.domainScript) {
    el.dataset.domainScript = attrs.domainScript;
  }
  if (attrs.className) el.className = attrs.className;
  if (attrs.async) el.async = true;
  if (text) el.text = text;
  document.head.appendChild(el);
}

export function injectProdConsentTags(
  isProd = import.meta.env.PROD,
  env: RuntimeEnv = (globalThis as typeof globalThis & EnvHost).env ?? {},
): void {
  if (!isProd) return;

  const adwordsKey = env.VITE_GOOGLE_ADWORDS_KEY ?? '';
  const analyticsKey = env.VITE_GOOGLE_ANALYTICS_KEY ?? '';

  insertScript({
    src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    type: 'text/javascript',
    charset: 'UTF-8',
    domainScript: '204c91a2-ea0c-4480-928b-495ab30e8d9b',
  });
  insertScript({ type: 'text/javascript' }, 'function OptanonWrapper() { }');
  insertScript(
    { type: 'text/javascript' },
    'window.recaptchaOptions = { enterprise: true };',
  );
  insertScript({
    type: 'text/plain',
    className: 'optanon-category-C0004',
    async: true,
    src: `https://www.googletagmanager.com/gtag/js?id=${adwordsKey}`,
  });
  insertScript(
    { type: 'text/plain', className: 'optanon-category-C0004' },
    [
      'window.dataLayer = window.dataLayer || [];',
      'function gtag(){dataLayer.push(arguments);}',
      "gtag('js', new Date());",
      `gtag('config', ${JSON.stringify(adwordsKey)});`,
      `gtag('config', ${JSON.stringify(analyticsKey)});`,
    ].join('\n'),
  );
}

injectProdConsentTags();
